
const WorksPD2021 = [
    {
        id: 1,
        name: '自動金魚すくい機 Automated Gold-fishing Machine',
        category: 'product',
        author: 'ミン リエ',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/01/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/01/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/01/01.jpg',
           '/project/2021/pd_exercise/01/02.jpg',
           '/project/2021/pd_exercise/01/03.jpg',
           '/project/2021/pd_exercise/01/04.jpg',
           '/project/2021/pd_exercise/01/05.jpg',
           '/project/2021/pd_exercise/01/06.jpg',
           '/project/2021/pd_exercise/01/07.jpg',
           '/project/2021/pd_exercise/01/08.jpg',
           '/project/2021/pd_exercise/01/09.jpg',
           '/project/2021/pd_exercise/01/10.jpg',
           '/project/2021/pd_exercise/01/11.jpg',
           '/project/2021/pd_exercise/01/12.jpg',
        ],
        galleryImage: [],
    },
    {
        id: 2,
        name: '雨飴 AME-AME',
        category: 'product',
        author: '黒木 夕希帆',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/02/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/02/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/02/01.jpg',
           '/project/2021/pd_exercise/02/02.jpg',
           '/project/2021/pd_exercise/02/03.jpg',
           '/project/2021/pd_exercise/02/04.jpg',
           '/project/2021/pd_exercise/02/05.jpg',
           '/project/2021/pd_exercise/02/06.jpg',
           '/project/2021/pd_exercise/02/07.jpg',
           '/project/2021/pd_exercise/02/08.jpg',
        ],
        galleryImage: [
           '/project/2021/pd_exercise/02/g_01.jpg',
           '/project/2021/pd_exercise/02/g_02.jpg',
           '/project/2021/pd_exercise/02/g_03.jpg',
           '/project/2021/pd_exercise/02/g_04.jpg',
           '/project/2021/pd_exercise/02/g_05.jpg',
           '/project/2021/pd_exercise/02/g_06.jpg',
           '/project/2021/pd_exercise/02/g_07.jpg',
           '/project/2021/pd_exercise/02/g_08.jpg',
           '/project/2021/pd_exercise/02/g_09.jpg',
           '/project/2021/pd_exercise/02/g_10.jpg',
           '/project/2021/pd_exercise/02/g_11.jpg',
           '/project/2021/pd_exercise/02/g_12.jpg',
           '/project/2021/pd_exercise/02/g_13.jpg',
           '/project/2021/pd_exercise/02/g_14.jpg',
           '/project/2021/pd_exercise/02/g_15.jpg',
           '/project/2021/pd_exercise/02/g_16.jpg',
           '/project/2021/pd_exercise/02/g_17.jpg',
           '/project/2021/pd_exercise/02/g_18.jpg',
           '/project/2021/pd_exercise/02/g_19.jpg',
        ]
    },
    {
        id: 3,
        name: '視覚と嗅覚で楽しむお香 hakanasa',
        category: 'product',
        author: '西川 耕平',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/03/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/03/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/03/01.jpg',
           '/project/2021/pd_exercise/03/02.jpg',
           '/project/2021/pd_exercise/03/03.jpg',
           '/project/2021/pd_exercise/03/04.jpg',
           '/project/2021/pd_exercise/03/05.jpg',
           '/project/2021/pd_exercise/03/06.jpg',
           '/project/2021/pd_exercise/03/07.jpg',
           '/project/2021/pd_exercise/03/08.jpg',
           '/project/2021/pd_exercise/03/09.jpg',
           '/project/2021/pd_exercise/03/10.jpg',
           '/project/2021/pd_exercise/03/11.jpg',
           '/project/2021/pd_exercise/03/12.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/03/g_01.jpg',
            '/project/2021/pd_exercise/03/g_02.jpg',
            '/project/2021/pd_exercise/03/g_03.jpg',
            '/project/2021/pd_exercise/03/g_04.jpg',
            '/project/2021/pd_exercise/03/g_05.jpg',
            '/project/2021/pd_exercise/03/g_06.jpg',
            '/project/2021/pd_exercise/03/g_07.jpg',
            '/project/2021/pd_exercise/03/g_08.jpg',
            '/project/2021/pd_exercise/03/g_09.jpg',
            '/project/2021/pd_exercise/03/g_10.jpg',
            '/project/2021/pd_exercise/03/g_11.jpg',
            '/project/2021/pd_exercise/03/g_12.jpg',
        ],
    },
    {
        id: 4,
        name: '四季石鹸 「季節を持ち歩く」紙石鹸',
        category: 'product',
        author: '藤坂 潮音',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/04/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/04/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/04/01.jpg',
           '/project/2021/pd_exercise/04/02.jpg',
           '/project/2021/pd_exercise/04/04.jpg',
           '/project/2021/pd_exercise/04/04.jpg',
           '/project/2021/pd_exercise/04/05.jpg',
           '/project/2021/pd_exercise/04/06.jpg',
           '/project/2021/pd_exercise/04/07.jpg',
           '/project/2021/pd_exercise/04/08.jpg',
           '/project/2021/pd_exercise/04/09.jpg',
           '/project/2021/pd_exercise/04/10.jpg',
           '/project/2021/pd_exercise/04/11.jpg',
           '/project/2021/pd_exercise/04/12.jpg',
           '/project/2021/pd_exercise/04/13.jpg',
           '/project/2021/pd_exercise/04/14.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/04/g_01.jpg',
            '/project/2021/pd_exercise/04/g_02.jpg',
            '/project/2021/pd_exercise/04/g_03.jpg',
            '/project/2021/pd_exercise/04/g_04.jpg',
            '/project/2021/pd_exercise/04/g_05.jpg',
            '/project/2021/pd_exercise/04/g_06.jpg',
            '/project/2021/pd_exercise/04/g_07.jpg',
            '/project/2021/pd_exercise/04/g_08.jpg',
            '/project/2021/pd_exercise/04/g_09.jpg',
            '/project/2021/pd_exercise/04/g_10.jpg',
            '/project/2021/pd_exercise/04/g_11.jpg',
        ],
    },
    {
        id: 5,
        name: '兜型ヘッドフォン KABUTTOKO',
        category: 'product',
        author: '三代 晃司',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/05/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/05/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/05/01.jpg',
           '/project/2021/pd_exercise/05/02.jpg',
           '/project/2021/pd_exercise/05/04.jpg',
           '/project/2021/pd_exercise/05/04.jpg',
           '/project/2021/pd_exercise/05/05.jpg',
           '/project/2021/pd_exercise/05/06.jpg',
           '/project/2021/pd_exercise/05/07.jpg',
           '/project/2021/pd_exercise/05/08.jpg',
           '/project/2021/pd_exercise/05/09.jpg',
           '/project/2021/pd_exercise/05/10.jpg',
           '/project/2021/pd_exercise/05/11.jpg',
           '/project/2021/pd_exercise/05/12.jpg',
           '/project/2021/pd_exercise/05/13.jpg',
        ],
        galleryImage: [],
    },
    {
        id: 6,
        name: '〜お香の新たな世界へ〜 KOUHIKI',
        category: 'product',
        author: '小泉 海斗',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/06/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/06/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/06/01.jpg',
           '/project/2021/pd_exercise/06/02.jpg',
           '/project/2021/pd_exercise/06/04.jpg',
           '/project/2021/pd_exercise/06/04.jpg',
           '/project/2021/pd_exercise/06/05.jpg',
           '/project/2021/pd_exercise/06/06.jpg',
           '/project/2021/pd_exercise/06/07.jpg',
           '/project/2021/pd_exercise/06/08.jpg',
           '/project/2021/pd_exercise/06/09.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/06/g_01.jpg',
            '/project/2021/pd_exercise/06/g_02.jpg',
            '/project/2021/pd_exercise/06/g_03.jpg',
            '/project/2021/pd_exercise/06/g_04.jpg',
            '/project/2021/pd_exercise/06/g_05.jpg',
            '/project/2021/pd_exercise/06/g_06.jpg',
            '/project/2021/pd_exercise/06/g_07.jpg',
            '/project/2021/pd_exercise/06/g_08.jpg',
            '/project/2021/pd_exercise/06/g_09.jpg',
            '/project/2021/pd_exercise/06/g_10.jpg',
            '/project/2021/pd_exercise/06/g_11.jpg',
            '/project/2021/pd_exercise/06/g_12.jpg',
            '/project/2021/pd_exercise/06/g_13.jpg',
            '/project/2021/pd_exercise/06/g_14.jpg',
            '/project/2021/pd_exercise/06/g_15.jpg',
        ],
    },
    {
        id: 7,
        name: 'BANKATOH 万華灯 映す万華鏡',
        category: 'product',
        author: '竹田 彩花',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/07/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/07/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/07/01.jpg',
           '/project/2021/pd_exercise/07/02.jpg',
           '/project/2021/pd_exercise/07/04.jpg',
           '/project/2021/pd_exercise/07/04.jpg',
           '/project/2021/pd_exercise/07/05.jpg',
           '/project/2021/pd_exercise/07/06.jpg',
           '/project/2021/pd_exercise/07/07.jpg',
           '/project/2021/pd_exercise/07/08.jpg',
           '/project/2021/pd_exercise/07/09.jpg',
           '/project/2021/pd_exercise/07/10.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/07/g_01.jpg',
            '/project/2021/pd_exercise/07/g_02.jpg',
            '/project/2021/pd_exercise/07/g_03.jpg',
            '/project/2021/pd_exercise/07/g_04.jpg',
            '/project/2021/pd_exercise/07/g_05.jpg',
            '/project/2021/pd_exercise/07/g_06.jpg',
            '/project/2021/pd_exercise/07/g_07.jpg',
            '/project/2021/pd_exercise/07/g_08.jpg',
            '/project/2021/pd_exercise/07/g_09.jpg',
            '/project/2021/pd_exercise/07/g_10.jpg',
            '/project/2021/pd_exercise/07/g_11.jpg',
            '/project/2021/pd_exercise/07/g_12.jpg',
            '/project/2021/pd_exercise/07/g_13.jpg',
            '/project/2021/pd_exercise/07/g_14.jpg',
            '/project/2021/pd_exercise/07/g_15.jpg',
            '/project/2021/pd_exercise/07/g_16.jpg',
            '/project/2021/pd_exercise/07/g_17.jpg',
            '/project/2021/pd_exercise/07/g_18.jpg',
            '/project/2021/pd_exercise/07/g_19.jpg',
            '/project/2021/pd_exercise/07/g_20.jpg',
            '/project/2021/pd_exercise/07/g_21.jpg',
            '/project/2021/pd_exercise/07/g_22.jpg',
            '/project/2021/pd_exercise/07/g_23.jpg',
            ],
    },
    {
        id: 8,
        name: '「筆」型ペン立て FUDE stand',
        category: 'product',
        author: '山田 蒼太',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/08/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/08/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/08/01.jpg',
           '/project/2021/pd_exercise/08/02.jpg',
           '/project/2021/pd_exercise/08/04.jpg',
           '/project/2021/pd_exercise/08/04.jpg',
           '/project/2021/pd_exercise/08/05.jpg',
           '/project/2021/pd_exercise/08/06.jpg',
           '/project/2021/pd_exercise/08/07.jpg',
           '/project/2021/pd_exercise/08/08.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/08/g_01.jpg',
            '/project/2021/pd_exercise/08/g_02.jpg',
            '/project/2021/pd_exercise/08/g_03.jpg',
            '/project/2021/pd_exercise/08/g_04.jpg',
            '/project/2021/pd_exercise/08/g_05.jpg',
            '/project/2021/pd_exercise/08/g_06.jpg',
            '/project/2021/pd_exercise/08/g_07.jpg',
            '/project/2021/pd_exercise/08/g_08.jpg',
            '/project/2021/pd_exercise/08/g_09.jpg',
            '/project/2021/pd_exercise/08/g_10.jpg',
        ],
    },
    {
        id: 9,
        name: '帯花 -ohana- 帯に咲くスマホケース',
        category: 'product',
        author: '内山 穂花',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/09/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/09/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/09/01.jpg',
           '/project/2021/pd_exercise/09/02.jpg',
           '/project/2021/pd_exercise/09/04.jpg',
           '/project/2021/pd_exercise/09/04.jpg',
           '/project/2021/pd_exercise/09/05.jpg',
           '/project/2021/pd_exercise/09/06.jpg',
           '/project/2021/pd_exercise/09/07.jpg',
           '/project/2021/pd_exercise/09/08.jpg',
           '/project/2021/pd_exercise/09/09.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/09/g_01.jpg',
            '/project/2021/pd_exercise/09/g_02.jpg',
            '/project/2021/pd_exercise/09/g_03.jpg',
            '/project/2021/pd_exercise/09/g_04.jpg',
        ],
    },
    {
        id: 10,
        name: '灯る音',
        category: 'product',
        author: '赤木 勇太',
        image: '/oitid/student/assets/images/project/2021/pd_exercise/10/01.jpg',
        background: '/oitid/student/assets/images/project/2021/pd_exercise/10/01.jpg',
        presentationImage: [
           '/project/2021/pd_exercise/10/01.jpg',
           '/project/2021/pd_exercise/10/02.jpg',
           '/project/2021/pd_exercise/10/04.jpg',
           '/project/2021/pd_exercise/10/04.jpg',
           '/project/2021/pd_exercise/10/05.jpg',
           '/project/2021/pd_exercise/10/06.jpg',
           '/project/2021/pd_exercise/10/07.jpg',
           '/project/2021/pd_exercise/10/08.jpg',
           '/project/2021/pd_exercise/10/09.jpg',
        ],
        galleryImage: [
            '/project/2021/pd_exercise/10/g_01.jpg',
            '/project/2021/pd_exercise/10/g_02.jpg',
            '/project/2021/pd_exercise/10/g_03.jpg',
            '/project/2021/pd_exercise/10/g_04.jpg',
            '/project/2021/pd_exercise/10/g_05.jpg',
            '/project/2021/pd_exercise/10/g_06.jpg',
            '/project/2021/pd_exercise/10/g_07.jpg',
            '/project/2021/pd_exercise/10/g_08.jpg',
            '/project/2021/pd_exercise/10/g_09.jpg',
            '/project/2021/pd_exercise/10/g_10.jpg',
            '/project/2021/pd_exercise/10/g_11.jpg',
            '/project/2021/pd_exercise/10/g_12.jpg',
            '/project/2021/pd_exercise/10/g_13.jpg',
            '/project/2021/pd_exercise/10/g_14.jpg',
            '/project/2021/pd_exercise/10/g_15.jpg',
        ],
    },
]

export default WorksPD2021